module.exports = __webpack_public_path__ + "static/media/example-suppressions-list.e52ab8e7.csv";